const initialState = {
  data: [],
};
  
const udzialyKontaReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UDZIALY_KONTA':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default udzialyKontaReducer;